import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Remaining to repay' },
  descriptionFirst: {
    defaultMessage:
      'You don’t have enough funds in your wallet to repay the full amount. If you proceed to repay with your current amount of funds, you will still have a small borrowing position in your dashboard.',
  },
});
